import { ISelectOption } from 'components/forms/Selects'
import upperCase from 'lodash/upperCase'
import { $enum } from 'ts-enum-util'
import { ICertificationCode } from 'types/FMSGraphqlTypes'
import { CERTIFICATION_CODE_LABELS } from '../constants'

export const getCertificationTitleOptions = (): ISelectOption<ICertificationCode>[] => {
  return $enum(ICertificationCode)
    .getValues()
    .map(code => ({
      label: `${CERTIFICATION_CODE_LABELS[code]} (${upperCase(code)})`,
      value: code,
    }))
}
